import { DEVURL, PPURL, SITURL } from '../constants';
import HookLoader from './HookLoader/HookLoader';
import useToken from './useToken';

const win: any = window;
const baseUrl = window.location.origin.includes('localhost') ? "http://ssta004:8080" : window.location.origin;

interface DAPIProps {
  setDAPIToken: React.Dispatch<React.SetStateAction<boolean>>;
}

interface APIGEEProps {
  setApigeeToken: React.Dispatch<React.SetStateAction<boolean>>;
}

const DAPIClientToken = ({ setDAPIToken }: DAPIProps) => {
  let utilUrl = baseUrl;

  if (baseUrl.includes('apisit')) {
    utilUrl = SITURL;
  } else if (baseUrl.includes('apipreprod')) {
    utilUrl = PPURL;
  } else if (baseUrl.includes('apidev')) {
    utilUrl = DEVURL;
  }

  const url = `${utilUrl}/mobilyTheme4/BzFvwmzXvs`;
  const req = { "dataT": "dapicl" }
  const { response, loading } = useToken(url, req, setDAPIToken);

  if (response) {
    !!!win["dapiToken"] && (win["dapiToken"] = response);
  }
  //console.log("dapiToken", response)
  return (
    <>
      {loading && <HookLoader loading={loading} />}
    </>
  )
}

const ApigeeClientToken = ({ setApigeeToken }: APIGEEProps) => {
  let utilUrl = baseUrl;

  if (baseUrl.includes('apisit')) {
    utilUrl = SITURL;
  } else if (baseUrl.includes('apipreprod')) {
    utilUrl = PPURL;
  } else if (baseUrl.includes('apidev')) {
    utilUrl = DEVURL;
  }

  const url = `${utilUrl}/mobilyTheme4/BzFvwmzXvs`;
  const req = { "dataT": "apigee" }
  const { response, loading } = useToken(url, req, setApigeeToken);

  if (response) {
    !!!win["apigeeClientToken"] && (win["apigeeClientToken"] = response);
  }
  //console.log("apigeeClientToken", response)

  return (
    <>
      {loading && <HookLoader loading={loading} />}
    </>
  )
}

export { DAPIClientToken, ApigeeClientToken }